import ChangePassword from '../../pages/ChangePassword'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { useChangePassword } from '../../hooks/useChangePassword'

function ChangePasswordWrapper() {
  const { errorCode, processed, disabledForm, submit } = useChangePassword()

  return (
    <ChangePassword
      errorCode={errorCode}
      processed={processed}
      disabledForm={disabledForm}
      onSubmit={submit}
    />
  )
}

export default withCenteredBaseWithMenu(ChangePasswordWrapper)
